import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CaracteristicaValor } from '../../../../../interfaces/valor-caracteristica';

@Component({
  selector: 'app-valor-caracteristica',
  templateUrl: './valor-caracteristica.component.html',
  styleUrls: ['./valor-caracteristica.component.scss']
})
export class ValorCaracteristicaComponent implements OnInit {
  @Input() valor: CaracteristicaValor = null;
  @Output() onValorCaracteristicaInput = new EventEmitter(); // datos del formulario cambian
  @Output() formState = new EventEmitter(); // emite el estado del formulario

  descripcionFormControl = new FormControl('', [
    Validators.required
  ]);

  constructor() { }

  ngOnInit() {
    if (this.valor == null) {
      // si no recibi una caracteristica para editar, creamos una nueva
      this.valor = new CaracteristicaValor();
    }
  }

  onInput(): void { // cuando cambia un dato emitimos un evento
    this.onValorCaracteristicaInput.emit();
  }

  getCaracteristicaValor(): CaracteristicaValor {
    // revisar las validaciones
    if (this.descripcionFormControl.hasError('required')) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.descripcionFormControl.markAsTouched();

      throw "Datos incorrectos";
    }

    return this.valor;
  }
}
